import { BusinessAnalyticsLayout } from "../layouts/BusinessAnalyticsLayout";
import { BusinessAnalyticsInstance } from "../utils/businessAnalyticsClass";
import { Dashboard } from "./DashboardPage";

export const FollowersAnalyticsPage = () => {
  const initializeBusinessAnalytics = async () => {
    await BusinessAnalyticsInstance.initialize();
  };

  return (
    <Dashboard header="Follower Analytics">
      <BusinessAnalyticsLayout actions={{ get: initializeBusinessAnalytics }}></BusinessAnalyticsLayout>
    </Dashboard>
  );
};
